<template>
  <v-container id="app-credit-carte">
    <!-- ***********************
    ********** SEARCH **********
    ************************ -->
    <v-card
      light
      class="ma-1 pa-2"
      width="100%"
    >
      <v-text-field
        v-model="nomClient"
        :label="$t('field.client')"
        class="needsclick"
      />
      <v-select
        v-model="idNomCarte"
        :label="$t('field.type_carte')"
        :items="typesCarteFiltered"
        class="needsclick"
      >
        <template v-slot:item="{item}">
          <img
            v-if="item.logo"
            :src="item.logo"
            alt="logo"
            width="30"
            class="mr-2"
          >
          {{ item.text }}
        </template>
      </v-select>
      <v-text-field
        v-model="dateFinValid"
        :label="$t('field.date_fin_validite')"
        class="needsclick"
        name="dateFinValid"
        type="date"
        readonly
        @click="clickDate"
      />
      <v-text-field
        v-show="isCarte"
        :value="$amount(montant)"
        append-icon="mdi-currency-eur"
        :label="$t('words.amount')"
        inputmode="decimal"
        name="quantity"
        class="needsclick"
        readonly
        @click="showAmountEntry = true"
      />
    </v-card>

    <bottom-action
      btn-del
      btn-cancel
      btn-valid
      :btn-valid-disabled="btnValidDisabled"
      @del="del"
      @cancel="cancel"
      @valid="valid"
    />

    <!-- ****************************
    ********** DATE DIALOG **********
    ***************************** -->
    <date-dialog
      v-model="showDateEntry"
      btn-class="right success"
      hide-overlay
      outlined
      :use-listener="showDateEntry"
      :default-date="dateFinValid"
      @del="closeDate"
      @cancel="cancel"
      @valid="checkDate"
    />

    <!-- ******************************
    ********** AMOUNT DIALOG **********
    ******************************* -->
    <keyboard-dialog
      v-model="showAmountEntry"
      :screen-title="$t('field.amount_reloading')"
      use-default-screen
      auto-close
      @valid="montant = arguments[0]"
    />
  </v-container>
</template>

<script>
import DateDialog from '@/components/modal/DateDialog'
import { ActionEnum, ServerEnum } from '@/modules/Enums'
import { $amount } from '@/modules/Utils'
import KeyboardDialog from '@/components/modal/KeyboardDialog.vue'

export default {
  name: 'CreditGift',

  components: {
    KeyboardDialog,
    DateDialog
  },

  props: {
    creditGiftParams: { type: Object, default: null }
  },

  data () {
    return {
      nomClient: null,
      idNomCarte: null,
      montant: 0,
      showDateEntry: false,
      dateFinValid: null,
      showAmountEntry: false,
      typeSupport: false,
      isCarte: false,
      nbMoisValidite: null,
      libelle: null,
    }
  },

  computed: {
    typesCarte () {
      return this.$store.getters.programmesKDO
    },
    favoriteScan () {
      return this.$store.getters.favoriteScan !== null ? this.$store.getters.favoriteScan : 'scan-qrcode'
    },
    typesCarteFiltered () {
      const res = []
      this.typesCarte.forEach(type => {
       if ((this.$store.getters.chequeCreditAccept && type.IDTypePorteMonnaie === ServerEnum.typePorteMonnaieCheque) || (this.$store.getters.carteCreditAccept && type.IDTypePorteMonnaie === ServerEnum.typePorteMonnaieCarte)) {
         res.push({
           value: type.IDNomCarte,
           text: type.Libelle,
           logo: type.Image
         })
       }
      })
      return res
    },
    btnValidDisabled () {
      return this.nomClient === null || this.nomClient === '' || this.dateFinValid === null || this.idNomCarte === null || (this.isCarte && (this.montant === '' || this.montant === null || this.montant === 0))
    }
  },

  watch: {
    idNomCarte (value) {
      this.typesCarte.forEach((elem) => {
        if (elem.IDNomCarte === value) {
          this.isCarte = elem.IDTypePorteMonnaie === ServerEnum.typePorteMonnaieCarte
          this.typeSupport = elem.IDTypePorteMonnaie
          this.libelle = elem.Libelle
          this.nbMoisValidite = elem.NbMoisFinValidite ?? 12
          this.dateFinValid = this.calculDefaultDate()
        }
      })
    }
  },

  mounted () {
    if (this.$store.state.teleparameters === null) {
      this.$router.replace('/')
      return
    }

    this.$emit('title', this.$i18n.t('title.parameters_lot_credit'))
    if (this.creditGiftParams !== null) {
      this.dateFinValid = this.creditGiftParams.dateFinValid
      this.montant = this.creditGiftParams.montant
      this.nomClient = this.creditGiftParams.nomClient
      this.idNomCarte = this.creditGiftParams.idNomCarte
      this.labelTypeCarte = this.creditGiftParams.labelTypeCarte
      this.typeSupport = this.creditGiftParams.typeSupport
    } else {
      this.dateFinValid = this.calculDefaultDate()
      if (this.typesCarteFiltered.length === 1) {
        this.idNomCarte = this.typesCarteFiltered[0].value
      }
    }
  },

  methods: {
    $amount,
    del () {
     this.nomClient = null
     this.idNomCarte = null
     this.montant = null
     this.dateFinValid = this.calculDefaultDate()
    },
    cancel () {
      this.$router.replace('/home')
    },
    valid () {
      this.$store.commit('amount', this.montant)

      this.$router.replace({
        name: this.favoriteScan,
        params: {
          action: ActionEnum.giftCredit,
          mode: 'P',
          backToHome: true,
          creditGiftParams: {
            dateFinValid: this.dateFinValid,
            montant: parseInt(this.montant),
            nomClient: this.nomClient,
            idNomCarte: this.idNomCarte,
            labelTypeCarte: this.libelle,
            typeSupport: this.typeSupport
          },
        }
      })
    },
    closeDate () {
      this.showDateEntry = false
    },
    checkDate (date) {
      this.dateFinValid = date
      this.showDateEntry = false
    },
    clickDate (event) {
      this.showDateEntry = true
    },
    calculDefaultDate() {
      let nbMois = Number(this.nbMoisValidite)

      let result = new Date()
      // Ajouter nbMois
      result.setMonth(result.getMonth() + nbMois)

      // Aller au premier jour du mois suivant
      result.setMonth(result.getMonth() + 1, 1)

      // Reculer d'un jour pour obtenir le dernier jour du mois précédent
      result.setDate(result.getDate() - 1)

      return result.toISOString().substr(0, 10)
    }
  }
}
</script>
